import axios from '@/axios';

const RESOURCE_NAME = '/admin/notification-email-logs';

export default {
    getIndexList(data) {
        return axios.post(`${RESOURCE_NAME}/get-index-list`, data);
    },

    getDetails(id) {
        return axios.get(`${RESOURCE_NAME}/get-details?id=${id}`);
    },

    getObjectTypes() {
        return axios.get(`${RESOURCE_NAME}/get-object-types`);
    },
}
